import type { ReactNode } from 'react';
import { useEntityList } from '@backstage/plugin-catalog-react';
import { Alert } from '@backstage/ui';
import { DocsSection } from './DocsSection';
import { DocsTable } from './DocsTable';

export type EntityListDocsGridProps = {
  title: string;
  emptyState: ReactNode;
  errorTitle: string;
};

export const EntityListDocsGrid = ({
  title,
  emptyState,
  errorTitle,
}: EntityListDocsGridProps) => {
  const { loading, error, entities } = useEntityList();

  if (error) {
    return (
      <Alert
        status="danger"
        icon
        title={errorTitle}
        description={error.message}
      />
    );
  }

  return (
    <DocsSection title={title}>
      <DocsTable
        entities={entities}
        isPending={loading}
        emptyState={emptyState}
        hasFilter
      />
    </DocsSection>
  );
};
